<template>
  <div class="flex flex-col w-full h-full relative moltzernas"
       v-observe-visibility="{
         callback:visibilityChanged,
         intersection:{
           rootMargin: '-20% 0px -60% 0px',
         }
       }">
    <!--    <p class="text-white">{{gamedata.gamedata.build ? "BUILT" : "NO"}}</p>-->
      <runner-game ref='runnerGame'
        :gamedata='gamedata.gamedata'
        :user="pbcUser"
        :enable-packer='false'
        :enable-black-list-message='false'
        :user-freeplay-limit-reached='false'
        :new-user='false'
        :data='{}'
        :paused='(!ignoreGlobalPause && globalPlayingPaused) || !visible'
        :start-pixi='visible'
        class='w-full grow'
        :disable-resize='embedded'
        :tick-resolution='200'
        @first-frame='onGameStarted'
        @prompt-video='onPromptVideo'
        @tick='onTick'
        @game-state="onUpdateGameState"
        @interactive-type='onAddInteractive'
        @notify-tap='onNotifyTap'
        @error='onError'
        />

      <fill-loader v-if='componentLoadingState[0]' />

    <div v-if='state !== "loaded" && state !== "playing" && isError' class="w-full h-full flex flex-row" style='background-color: rgba(255,255,255,0.3)'>
      <game-state
        class="mx-4 md:mx-auto max-w-md max-h-md self-center"
        state="error"
        :message="errorMessage"
        @restart="state = 'playing'"
        />
    </div>
    <div v-else-if='state !== "loaded" && state !== "playing"' class="w-full h-full flex flex-row" style='background-color: rgba(255,255,255,0.3)'>
      <game-state 
        class="mx-4 md:mx-auto max-w-md max-h-md self-center"
        :state="state"
        :message="stateMessage"
        @restart="state = 'playing'"
        />
    </div>
      <!--
    <editor-player-toolbar class="w-full flex-none" @edit="$emit('edit')" />
      -->
  </div>
</template>
<script>
import PlayCircleOutline from '@icons/PlayCircleOutline.vue';
import { debounce } from 'lodash';
import { mapState } from 'vuex';
import ComponentLazyLoader from '@/lazyloader.js';
import GameState from '@ui/organisms/GameState.vue';
import getProvider from '@/ui/apiprovider.js';
const {componentLoadingState, fn:RunnerGame}  = ComponentLazyLoader(() => import(/* webpackChunkName: "play" */ '@/play/components/RunnerGame.vue'));
export default {
  provide: getProvider,
  inject: ['api'],
  props: {
    id: {
      type: String,
      default: 'unknown'
    },
    gamedata: {
      type: Object,
      required: true
    },
    embedded: {
      type: Boolean,
      default: true
    },
    loadData:{
      type:Boolean,
      default:false
    },
    ignoreGlobalPause:{
      type:Boolean,
      default:false
    },
  },
  data() {
    const gamedata = this.gamedata.gamedata;
    const onNotifyTap = debounce(this._onNotifyTap.bind(this), 800);

    return {
      visible: false,
      pbcUser: {
        id: 'cheese'
      },
      state:'playing',
      stateMessage:'',
      componentLoadingState,
      interactionType: 'none',
      isError: false,
      errorMessage: '',
      timeSinceStart:0,
      onNotifyTap,
      hasStarted:false
    }
  },
  methods: {
    onGameStarted() {
      this.hasStarted = true;
    },
    onPromptVideo(data) {
      this.$emit('prompt-video', data);
    },
    onTick({dt,timeSinceStart}) {
      this.timeSinceStart = timeSinceStart/1000;
    },
    onError(errorMessage) {
      this.isError = true;
      this.errorMessage = errorMessage;
    },
    onAddInteractive({type}) {
      if (this.interactionType === 'none' && type === 'tapcontroller') {
        this.interactionType = 'tap';
      } else if (type === 'swipecontroller') {
        this.interactionType = 'swipe';
      } else if (type === 'feature') {
        this.interactionType = 'swipe';
      }
    },
    onUpdateGameState(state, message) {
      this.state = state;
      this.stateMessage = message;
      this.$emit('state', state);
    },
    visibilityChanged(visible, a) {
      console.log('visibility changed', this.id, visible);
      this.visible = visible;
      if (visible) {
        this.$emit('view-post', this.id);
      }
      //if (visible && this.$refs.runnerGame) {
        //this.$refs.runnerGame.restartGame(false);
      //}
    },
    _onNotifyTap({component}) {
      this.$ana.track({
        eventCategory:'interaction',
        eventAction:'tap',
        extra:{
          //cid:component.id,
          id:this.id
        }
      });
    }
  },
  components: {
    RunnerGame,
    GameState,
  },
  async mounted() {
  },
  watch: {
    hasStarted(nv) {
      this.$emit("started", nv);
    },
    visible(nv) {
      if (!nv) {
        this.hasStarted = false;
      }
      this.$emit('visible', nv);
    },
  },
  computed:{
    ...mapState(['globalPlayingPaused'])
  }

}
</script>
